import { useEffect, useRef, useState } from 'react'

import { getRentalPortalListingsStatistic } from '../../../../../api'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { LISTINGS_EXTRA_FILTERS } from '../../RentalPortalListings.constants'

export function useRentalPortalListingsStatistic(filterValues) {
  const [statistic, setStatistic] = useState(EMPTY_OBJECT)

  const lastLoadIdRef = useRef(0)

  function handleReloadStatistic() {
    lastLoadIdRef.current += 1

    const loadId = lastLoadIdRef.current

    getRentalPortalListingsStatistic({
      filters: { ...filterValues, ...LISTINGS_EXTRA_FILTERS },
    })
      .then(({ data }) => {
        if (loadId === lastLoadIdRef.current) {
          setStatistic(data)
        }
      })
      .catch(() => {
        if (loadId === lastLoadIdRef.current) {
          setStatistic(EMPTY_OBJECT)
        }
      })
  }

  useEffect(() => {
    if (filterValues) {
      handleReloadStatistic()
    }
  }, [filterValues])

  return { handleReloadStatistic, statistic }
}
